import { useStore } from 'vuex'
import { onMounted, ref } from 'vue'

import nonEmptyStringValidator from "foundation/js/inputValidators/nonEmptyStringValidator";
import FormInputDropdown from 'components/FormInputDropdown/FormInputDropdown.vue'

export default {
    name: "DropdownWithTags",
    components: {
        FormInputDropdown
    },
    props: {
        initTags: {
            type: Array,
            required: false,
            default: null
        },
        tagsTitle: {
            type: String,
            required: true,
        },
        onChangeCallback: {
            type: Function,
            required: true,
            default: () => {}
        },
        fieldName: {
            type: String,
            required: true
        },
        legend: {
            type: String,
            required: false
        },
        isRequired: {
            type: Boolean,
            required: false
        },
        label: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            required: false
        },
        isValidationError: {
            // this props works in 2 ways
            // 1 - checkout page on webshop handles all field validation and will output result here
            // 2 - other forms like SFL forms will use this field to notify the field to show its possible errors
            type: Boolean,
            required: false,
            default: null
        },
        errorMessageLabel: {
            type: String,
            required: false
        },
        selectOptions: {
            type: Object,
            required: false
        },
    },
    setup(props){
        const subjectOptions = ref(props.selectOptions.options)
        const tagsDropdown = ref()
        const tags = ref([])
        const returnTags = ref([])

        onMounted(() => {
            if (props.initTags && props.initTags.length > 0) {
                tags.value = props.initTags            
                returnTags.value = tags.value.map(tag => props.selectOptions.options.find(option => option.name === tag).value)
                props.onChangeCallback(returnTags.value)
            }
        })

        const handleSubjectsOptions = function (e) {
            
            const tagId = e.target.value
            const name = getTagName(tagId)
            
            const alreadyExisting = tags.value.find(tag => tag === name)

            if(!alreadyExisting) {
                tags.value.push(name)
                returnTags.value.push(tagId)
                props.onChangeCallback(returnTags.value)
            }     
        }

        const getTagName = function(newTag) {
            let result = newTag
            props.selectOptions.options.map((item) => {
                if(item.value === newTag) {
                    newTag = item.name
                }
            })
            return newTag
        }

        const handleDeleteTag = function (clickedTagName) { 
           tags.value = tags.value.filter(tag => tag !== clickedTagName)
           returnTags.value = tags.value.map(tag => props.selectOptions.options.find(option => option.name === tag).value)
           props.onChangeCallback(returnTags.value)
           const dropDownWrapper = document.querySelector('.kb-js--dropdown-with-tags-wrapper')
           const dropDown = dropDownWrapper.querySelector('#dropdown')
           dropDown.focus()
        }

        return {
            subjectOptions,
            tags,
            tagsDropdown,
            nonEmptyStringValidator,
            handleSubjectsOptions,
            handleDeleteTag
        }
    }
}